const colors= {
  headColor:"#01917E",
  headFontColor:"ffffff",
  btnHoverColor:"rgba(5, 167, 146, 0.08)",
  dropAnchorPointBtn : "#E4485B",
  anchorPointBtnBorder : "#CF3F50",
  address : "#D8D6D6",
  disabledColor: "#CCCCCC",
  borderColor: "#D8D8D8",
}
const styles ={
    root: {
      width:"230px",
      height:"165px"
    },
    anchorPointRoot:{
      width:"200px",
      // height:"138px"
      paddingBottom:12
    },
    table:{
      height:"100%",
      width:"100%",
    },
    tableHead: {
      backgroundColor: colors.headColor,
    },
    tableHeadHeight:{
      height:"52px",
      '& $tableHeaderCell':{
        paddingTop: "6px",
      }
    },
    tableHeaderCell: {
      color: colors.headFontColor,
      borderBottom: 0,
      fontSize:"12px",
    },
    tableHeadCell: {
      color: colors.headFontColor,
      borderBottom: 0,
      fontSize:"12px",
    },
    tableRowRoot: {
      height: "25px",
    },
    anchorPointTableRowRoot: {
      height: 24,
      '& $anchorPointBtnCell':{
        borderBottom:"0px",
        paddingTop:8,
        paddingLeft:"14px"
      },
      '& $labelCell, & $dataCell':{
        paddingTop:8,
      },
      '& $dataCell':{
        display:"block",
        width: 100,
        paddingRight: 12,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace:"nowrap",
        boxSizing:"border-box",
        paddingLeft:2
      }

    },
    routeInfo:{
      float:"right",
      fontSize:"10px",
      paddingRight:"12px"
    },
    customerName:{
      float:"left",
      paddingLeft:"12px",
      overflow: "hidden",
      whiteSpace: "nowrap",
      lineHeight:"17px",
      width:"172px",
      textOverflow:"ellipsis"
    },
    address:{
      clear:"both",
      fontSize:"10px",
      lineHeight:"20px",
      color:colors.address,
      paddingLeft:"12px",
      overflow: "hidden",
      whiteSpace: "nowrap",
      height:"20px",
      width:"130px",
      textOverflow:"ellipsis",
      display: 'inline-block'
    },
    firstTableCell:{
      paddingTop:"10px",
    },
    lastTableCell:{
      paddingBottom:"15px",
    },
    popupDataStyle:{},
    labelCell: {
      borderBottom: 0,
      fontSize: 10,
      paddingLeft: "12px",
      lineHeight: "14px",
    },
    dataCell: {
      borderBottom: 0,
      fontSize: 12,
      //fontWeight:600,
      lineHeight:"17px",
      '&$firstTableCell':{
        paddingTop:"10px"
      },
      '&$lastTableCell':{
        paddingBottom:"15px",
      },
      '&$popupDataStyle':{
        paddingLeft:"12px"
      }
    },
    nameCellPadding:{
      paddingRight:"25px"
    },
    routePopupButton: {
      paddingRight:"5px",
    },
    popupButton: {
      fontSize: 9,
      padding:"0px",
      borderColor: colors.headColor,
      color: colors.headColor,
      fontWeight:"600",
      borderRadius: "2px",
      height:"25px",
      width:"101px",
      textTransform: "none",
      '&:hover':{
        backgroundColor: colors.btnHoverColor
      }
    },
    anchorPointBtn:{
      fontSize: 9,
      borderRadius: "2px",
      borderColor: colors.anchorPointBtnBorder,
      color: colors.dropAnchorPointBtn,
      height:"25px",
      width:"90%",
      fontWeight:"600",
      textTransform: "none",
    },
    tableButtonCell:{
      borderBottom:"0px",
      padding:"0px 4px 12px 10px",
      '&$tableButtonRight':{
        padding:"0px 10px 12px 4px",
      }
    },
    tableButtonRight:{},
    anchorPointBtnCell:{},
    routeNameInfo:{
      float:"left",
      paddingLeft:"12px"
    },
    startTime:{
      fontSize:"10px",
      lineHeight:"14px",
      float:"right",
      paddingRight:"12px"
    },
    headHeight:{
      height:"34px"
    },
    disabled:{
      cursor:"not-allowed",
      '& $disabledBtn':{
        borderColor: colors.anchorPointBtnBorder,
        color: colors.dropAnchorPointBtn,
      }
    },
    disabledBtn:{
    },
    progress:{
      color: colors.dropAnchorPointBtn,
    },
    rightCell:{
      width:100
    },
    nearbyRoutesStyle:{
      fontSize:"9px",
      lineHeight:"13px",
      color:colors.headColor,
      paddingLeft:"12px",
    },
    nearbyRoutesLabel:{
      textDecoration:"underline",
      '&:hover':{
        opacity:"0.8"
      }
    },
    zonePopUp:{
      width: "180px",
    },
    SpecialInstruction:{
      width: "100px",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
    dualCellLeft:{
        display: "inline-block", 
        paddingRight: "10px",
      },
    dualCellRight:{
        display: "inline-block", 
        paddingLeft: "10px",
        borderLeft: `1px solid ${colors.borderColor}`,
    },
    popupIconContainer:{
      float: "right",
      paddingRight: "10px", 
      paddingTop: "3px",
      display: "flex",
      alignItems: "center"
    },
    popupIcon:{
      display: "inline-block",
      paddingLeft: "3px",
      fontSize: "11px",
      fontWeight: "100",
    },
    routeStop:{
      width: "230px",
    },
    dividerStyle: {
      borderRight: `1px solid ${colors.borderColor}`,
      margin: "1 6 0 6",
      opacity: 0.5,
      borderWidth: "0.1px"
    },
  }
export default styles;